export const downloadFile = (fileUrl: string, fileName: string) => {
  const aElement = document.createElement("a");
  aElement.href = fileUrl;
  aElement.download = fileName;
  document.body.appendChild(aElement);
  aElement.click();
  document.body.removeChild(aElement);
};

export function saveBlobAsFile(blob: Blob, filename: string) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}